const t = {
  name: "Mobile",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.25 6C13.25 6.69 12.69 7.25 12 7.25C11.31 7.25 10.75 6.69 10.75 6C10.75 5.31 11.31 4.75 12 4.75C12.69 4.75 13.25 5.31 13.25 6Z" fill="currentColor"/>
<path d="M8 1C6.34315 1 5 2.34315 5 4V20C5 21.6569 6.34315 23 8 23H16C17.6569 23 19 21.6569 19 20V4C19 2.34315 17.6569 1 16 1H8ZM7 4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44772 17 4V20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20V4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Mobile
};
